import { render } from "./StafetMailEditorOverlay.vue?vue&type=template&id=7875ed44"
import script from "./StafetMailEditorOverlay.vue?vue&type=script&lang=js"
export * from "./StafetMailEditorOverlay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__